export const API_BASE = process.env.VUE_APP_API_BASE || "http://localhost:3100/api/admin";

export function apiOrigin() {
  return API_BASE.replace(/\/api\/admin\/?$/, "");
}
